/**
 * Storewide UpCart selling-plan filter [Kopstorm]
 * Hides Stay bundle plans 6210912506 / 6210945274 from the cart drawer
 * <select> on EVERY page (not just the bundle builder).
 *
 * Loaded from layout/theme*.liquid — do not gate on template.
 * CSS option{display:none} is ignored by Mac/iOS native pickers; we DELETE.
 */
(function () {
  var HIDE = ['6210912506', '6210945274'];

  function isHide(v) {
    v = String(v || '');
    for (var i = 0; i < HIDE.length; i++) {
      if (v.indexOf(HIDE[i]) !== -1) return true;
    }
    return false;
  }

  function stripSelect(sel) {
    if (!sel || !sel.options) return;
    for (var i = sel.options.length - 1; i >= 0; i--) {
      if (isHide(sel.options[i].value)) {
        try { sel.remove(i); } catch (e) {
          try { sel.options[i].parentNode.removeChild(sel.options[i]); } catch (e2) {}
        }
      }
    }
    var groups = sel.querySelectorAll('optgroup');
    for (var g = groups.length - 1; g >= 0; g--) {
      if (!groups[g].querySelector('option') && groups[g].parentNode) {
        groups[g].parentNode.removeChild(groups[g]);
      }
    }
  }

  function stripAll() {
    var sels = document.querySelectorAll(
      'select.upcart-subscription-upgrade-dropdown,' +
      'select[class*="SubscriptionUpgradesModule"],' +
      '#upCart select,' +
      '#UpcartPopup select'
    );
    for (var i = 0; i < sels.length; i++) stripSelect(sels[i]);
  }

  window.rhoStripUpcartBundlePlans = stripAll;

  /* Sync remove as React inserts options — before the next paint. */
  function nukeAdded(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.tagName === 'OPTION' && isHide(node.value)) {
      try { node.parentNode && node.parentNode.removeChild(node); } catch (e) {}
      return;
    }
    if (node.tagName === 'SELECT') {
      stripSelect(node);
      return;
    }
    if (node.querySelectorAll) {
      var opts = node.querySelectorAll('option');
      for (var i = 0; i < opts.length; i++) {
        if (isHide(opts[i].value)) {
          try { opts[i].parentNode.removeChild(opts[i]); } catch (e2) {}
        }
      }
      var sels = node.querySelectorAll('select');
      for (var s = 0; s < sels.length; s++) stripSelect(sels[s]);
    }
  }

  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var nodes = muts[i].addedNodes;
      if (!nodes) continue;
      for (var j = 0; j < nodes.length; j++) nukeAdded(nodes[j]);
      var t = muts[i].target;
      if (t && t.tagName === 'SELECT') stripSelect(t);
      if (t && t.tagName === 'OPTGROUP' && t.parentElement && t.parentElement.tagName === 'SELECT') {
        stripSelect(t.parentElement);
      }
    }
  });

  function observe() {
    try {
      mo.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
    stripAll();
  }

  /* Trap UpCart hooks — their aboveHeader script re-assigns these every paint. */
  function trap(name) {
    var store = null;
    if (typeof window[name] === 'function') store = window[name];
    try {
      Object.defineProperty(window, name, {
        configurable: true,
        enumerable: true,
        get: function () {
          return function () {
            if (typeof store === 'function') {
              try { store.apply(this, arguments); } catch (e) {}
            }
            stripAll();
          };
        },
        set: function (fn) { store = fn; }
      });
    } catch (e) {}
  }

  function onPointer(e) {
    var path = [];
    try { path = e.composedPath ? e.composedPath() : []; } catch (err) { path = []; }
    for (var i = 0; i < path.length; i++) {
      if (path[i] && path[i].tagName === 'SELECT') {
        stripSelect(path[i]);
        return;
      }
    }
    stripAll();
  }

  document.addEventListener('pointerdown', onPointer, true);
  document.addEventListener('touchstart', onPointer, true);
  document.addEventListener('mousedown', onPointer, true);
  document.addEventListener('focusin', onPointer, true);

  trap('upcartOnCartUpdated');
  trap('upcartOnCartLoaded');

  if (document.documentElement) observe();
  else document.addEventListener('DOMContentLoaded', observe);

  /* While cart is open, keep stripping — React can re-commit options. */
  setInterval(function () {
    if (document.querySelector('.upcartPopupShow, #UpcartPopup.upcartPopupShow')) {
      stripAll();
    }
  }, 250);
})();
